import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  OnDestroy,
  HostListener
} from '@angular/core';
// import { AuthService } from '../../auth/auth.service'
import {IMenu} from './nav.model';
import {Http, Response} from '@angular/http';
import {APP_CONFIG, AppConfig} from '../../config/app.config.module';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {NavService} from './nav.service';
import * as $ from 'jquery';
import {SearchService} from '../../search/search.service';
import {ToastrService} from 'ngx-toastr';
import {ISubscription} from 'rxjs/Subscription';
import {TopnavService} from '../topnav/topnav.service';
import {Title} from '@angular/platform-browser';
import {SharedService} from '../../common/shared.service';
import {PortalService} from '../../services/portal.service';

/**
 * Author: Sridhar Swaminathan
 *
 * Date Created: November 14th 2017
 *
 * Description: Component class for Header Main Navigation Menu
 **/
@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']

})
export class NavComponent implements OnInit, AfterViewInit, OnDestroy {

  // @HostListener('document:click', ['$event']) clickedOutside($event){
  //     // here you can hide your menu
  //     $('#searchDDown').css({ 'display': 'none' });
  //     // console.log("CLICKED OUTSIDE");
  // }

  menuModal: any;
  mobile: boolean;
  isOpen: boolean;
  @Output() menuClick = new EventEmitter();
  @Input() state: string;
  @Input() getPassPort: string;
  @Input() validMyIdentity: any;
  languageId: any;
  imgSrc: string;
  menus: IMenu[];
  articles: any[];
  lang = 'en';
  langId = 1;
  active_color = 'blue';
  inactive_color = 'red';
  setUrl = 'portal';
  menuId: number;
  popData: any;
  ser_word = "";
  page;
  suggestions: any = [];

  private articleUrl: string = this.config.urlArticle;
  private menuUrl: string = this.config.urlMenu;

  private subscriptionLang: ISubscription;
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS": "14px",
    "sizeM": "19px",
    "sizeL": "23px",
    "no_styles": "0.9em"
  };
  currUrl: string;
  public myflag: any;


  constructor(
    private activatedRoute: ActivatedRoute,
    private portalService: PortalService,
    private sharedService: SharedService,
    private translate: TranslateService,
    private titleService: Title,
    private toastr: ToastrService,
    @Inject(APP_CONFIG) private config: AppConfig,
    private http: Http,
    public navService: NavService,
    private topnavservice: TopnavService,
    private router: Router,
    private searchService: SearchService) {

    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {

      const myLang = translate.currentLang;

      if (myLang == 'en') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'en';
          this.langId = 1;
          this.languageId = 1;
          //this.titleService.setTitle("MyGOV - The Government of Malaysia's Official Portal");
          this.imgSrc = 'logo_en';
        });

      }
      if (myLang == 'ms') {

        translate.get('HOME').subscribe((res: any) => {
          this.lang = 'ms';
          this.langId = 2;
          this.languageId = 2;
          //this.titleService.setTitle("MyGOV - Portal Rasmi Kerajaan Malaysia");
          this.imgSrc = 'logo_ms';
        });
      }

      if (this.topnavservice.flagLang) {
        this.getMenu();
      }
    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data) => {
      this.fontSize = data;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language: "my"};
      } else {
        this.myflag = null;
      }
    });
  }

  ngOnInit() {

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
      //this.fontService.changeFontStyle();
    });


    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else {
        this.languageId = 1;
      }
    }
    this.currUrl = this.router.url.split("/")[1];

    //if (this.languageId === 1) {
    //    this.titleService.setTitle("MyGOV - The Government of Malaysia's Official Portal");
    //} else {
    //    this.titleService.setTitle("MyGOV - Portal Rasmi Kerajaan Malaysia");
    //}

    this.page = this.router.url.split('/')[1];
    this.isOpen = false;
    //
    this.imgSrc = 'logo_ms';
    this.getMenu();
    this.getPop();
    this.navService.ispopUpShow = false;
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
  }

  color: string = 'red';

  changeStyle($event) {
    this.color = $event.type == 'mouseover' ? 'animated fadeIn' : '';
  }

  handleClickMe(e) {
    this.menuClick.emit(e);
    this.menuId = e;
    // this.navService.triggerArticle('',this.langId, e);
  }

  ngAfterViewInit() {
    $(function () {
      $('#main-menu > li > a').css({'backgroundColor': '#2c2f6a', 'color': '#fff'});
      $('#main-menu > li > a.active').css('background-color', localStorage.getItem('themeColor'));
    });

    this.sharedService.loadFontSizeData();

  }


  clickPrevent(e) {
    e.preventDefault();
  }

  dropdownDisplay(action, e?) {
    e.preventDefault();
    e.stopPropagation();  // <- that will stop propagation on lower layers
    // console.log("CLICKED INSIDE, MENU WON'T HIDE");
    if (this.isOpen == true) {
      this.isOpen = false;
      $('#searchDDown').css({'display': 'none'});
    } else {
      this.isOpen = true;
      $('#searchDDown').css({'display': 'block'});
    }

    // let opened = this.isOpen;
    // $(function () {

    //     if (action == 'show' && opened == false) {
    //         $('#searchDDown').css({ 'display': 'block' });
    //         opened = true;

    //     } else if(action == 'show' && opened == true) {
    //         $('#searchDDown').css({ 'display': 'none' });
    //         opened = false;
    //     }

    // });
    // this.isOpen = opened;
  }

  getMenu() {
    if (!this.languageId) {
      this.languageId = 1;
    }
    this.navService.getMenuData(this.languageId)
      .subscribe(resMenuData => {
        this.menus = resMenuData
      });
  }

  getPop() {
    let body = {
      "size": 10,
      "filters": {}
    };
    this.navService.getPopularData(body)
      .subscribe(resPopularData => {
        this.popData = resPopularData
      });
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }

  getUrl() {
    return 'portal';
  }

  escapeRegExp(string) {

    string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    return string;
  }

  mainSearch(key) {

    if (key) {

      if (key.match(/script/gi)) { //  || key.match(/<\/?[^>]+(>|$)/g) || key.match(/[^a-zA-Z0-9 ]/g)
        key = '';
        this.ser_word = '';
        this.sharedService.showError(this.translate.instant('common.msg.validsearchKeyword'), '');
      } else {
        // key = decodeURI(key);
        // console.log({'escapeRegExp':this.navService.escapeRegExp(key)});

        if (key.match(/[a-zA-Z0-9]/g)) {

          // key = key.replace(/[^a-zA-Z0-9@&()[:space:]\.,'"\/-–]/g, "");

          this.page = this.router.url.split('/')[1];
          // console.log({'page':this.page});

          $('#searchDDown').css({'display': 'none'});
          localStorage.setItem('ser_word', key);

          key = key.replace(/[&]/g, "|").replace(/[%]/g, "_");
          // this.router.navigate([]);

          // this.router.navigate(['search'], { queryParams: { key: key } } );
          location.href = './search?key=' + key;
          // if(this.currUrl != 'search') {
          //     this.router.navigate(['search/', key]);
          // }

          this.internal(key);
        } else {
          console.log('symbols only not valid');
          // console.log('invalid');

          $('#searchDDown').css({'display': 'block'});

          key = '';
          this.ser_word = '';
          this.sharedService.showError(this.translate.instant('common.msg.validsearchKeyword'), '');
        }
      }

      // if(this.page == 'search')
      //     window.location.reload();

    } else {
      this.sharedService.showError(this.translate.instant('common.msg.searchKeyword'), '');
    }
  }

  mobileMainMenu() {
    alert('hello')
  }

  internal(key) {

    key = decodeURI(key);

    key = key.replace(/[^a-zA-Z0-9@&()[:space:]\.,'"\/-–]/g, "");

    let body = {
      "size": 10,
      "from": 0,
      "keyword": key,
      "filters": {
        "ranges":
          {
            "end_date": [
              {
                "gte": "now/d",
                "time_zone": "+08:00"
              }
            ]
          },
        "ref_language_id": this.languageId.toString()
      },
      "aggregations": [
        {
          "name": "histogram",
          "type": "dateHistogram",
          "field": "publish_date",
          "interval": "month",
          "time_zone": "+08:00",
          "minDocCount": 1,
          "size": 10
        },
        {
          "name": "filter_topic.category",
          "type": "filter",
          "field": "category.is_active",
          "filter": {
            "category.is_active": true
          },
          "subAggregation": {
            "name": "active_cat",
            "type": "terms",
            "field": "category.topic.raw",
            "size": "10"
          }
        },
        {
          "name": "filter_sub_topic.category",
          "type": "filter",
          "field": "category.is_active",
          "filter": {
            "category.is_active": true
          },
          "subAggregation": {
            "name": "active_cat",
            "type": "terms",
            "field": "category.sub_topic.raw",
            "size": "10"
          }
        }
      ]
    }

    this.searchService.getInternal(body).subscribe(
      data => {
        this.searchService.setIntData(data);
      });

  }

  getSuggestions(key) {
    // let corsURL = 'https://cors-anywhere.herokuapp.com/';
    // let headers = new Headers({'Content-Type': 'text/xml'})
    // headers.set('Accept', 'text/xml');
    // headers.set('Content-Type', 'text/xml');
    // headers.set('X-Requested-With', 'test');

    // this.loading = true;
    if (key && key.length != 0 && key.length >= 3) {
      // this.http.get(corsURL+'https://suggestqueries.google.com/complete/search?output=toolbar&hl=en&q='+key,{headers}).subscribe(res => {
      this.portalService.readPortal('google/api/searchsuggest', '', '', '', 'q=' + encodeURIComponent(key)).subscribe(res => {

          this.suggestions = res['suggestion'];

          if (this.suggestions.length != 0) {
            $('.hover_bkgr_fricc').css({'display': 'block'});
            // this.suggestions = this.convert2arr(res['_body']);
            this.addHighlight(key);
            this.navService.isNavSuggestionList = true;
            this.navService.ispopUpShow = true;
            // console.log({'suggestions':this.suggestions});
          } else {
            this.navService.isNavSuggestionList = false;
            this.navService.ispopUpShow = false;
            // this.loading = false;
          }

        },
        error => {
          console.log(error);
          // this.loading = false;
          //   this.loading = false;
          //   this.commonservice.showError(JSON.parse(error._body).statusDesc, '');
        });
    } else {
      this.navService.isNavSuggestionList = false;
      this.navService.ispopUpShow = false;
      // this.loading = false;
    }

  }

  closeList(e) {
    // console.log({'event':e});
    // console.log({'className':e.target.className});
    // console.log({'ispopUpShow':this.navService.ispopUpShow});
    // console.log({'isNavSuggestionList':this.navService.isNavSuggestionList});
    // console.log({'isHomeSearchSuggestionList':this.navService.isHomeSearchSuggestionList});
    // console.log({'isSearchSuggestionList':this.navService.isSearchSuggestionList});
    if (e.target.className === "hover_bkgr_fricc" && this.navService.ispopUpShow && (this.navService.isNavSuggestionList || this.navService.isHomeSearchSuggestionList || this.navService.isSearchSuggestionList)) {
      this.navService.ispopUpShow = false;
      this.navService.isNavSuggestionList = false;
      this.navService.isHomeSearchSuggestionList = false;
      this.navService.isSearchSuggestionList = false;
    }

    $('.hover_bkgr_fricc').css({'display': 'none'});
  }

  addHighlight(keyword) {
    let span1 = document.createElement("span");
    let maintxt;

    this.suggestions.forEach(el => {

      maintxt = el.data;
      // console.log({'maintxt':maintxt});

      if (maintxt !== "null") {
        let nameNode = document.createTextNode(maintxt);
        span1.appendChild(nameNode);
        // console.log({'keyword':keyword});

        let resStr = this.highlight_words(keyword, span1);
        // if(resStr.trim().length > 300){
        //   this.dataHilight = resStr.slice(0,300) + '...';
        // }else{
        // }
        el.hl = resStr;
        // this.dataHilight = el.data;
        // console.log({'dataHilight':this.dataHilight});
      } else {
        // this.dataHilight = '';
      }
    });

  }

  highlight_words(word, element) {
    let regex: any = "";
    if (word) {
      var resData;
      word = word.replace(/\W/gi, '');
      var str = word.split(" ");

      $(str).each(function () {
        //   console.log({'str':str});

        var term = word;
        var textNodes = $(element).contents().filter(function () {
          return this.nodeType === 3
        });
        textNodes.each(function () {

          var content = $(this).text();
          regex = new RegExp(term, "gi");

          resData = content.replace(regex, (match) => `<span class="highlightWord">${match}</span>`);
        });
      });
      return resData;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/header/nav/nav.component.ts